import * as React from "react";
import type { SVGProps } from "react";

interface BikeChangeProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const BikeChange = ({ cancelled = false, ...props }: BikeChangeProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="nonzero">
      <path
        fill="#FFF"
        d="m14.516 1.885 2.916 2.923a1.25 1.25 0 0 0 1.773 0c1.26-1.261 3.415-.369 3.415 1.414v9.519c0 1.781-2.154 2.674-3.414 1.414l-.936-.937-5.926 5.928a2 2 0 0 1-2.83 0l-2.907-2.907a1.27 1.27 0 0 0-1.782-.016c-1.26 1.262-3.415.37-3.415-1.413V8.29c0-1.782 2.155-2.674 3.414-1.414l.937.936 5.926-5.927a2 2 0 0 1 2.829 0"
      />
      <path
        fill="#3A1919"
        d="m14.02 2.38 2.4 2.401a1.3 1.3 0 0 1 0 1.837L4.33 18.728c-.819.82-2.22.24-2.22-.918V8.29c0-1.158 1.4-1.738 2.22-.92l1.43 1.432 6.422-6.422a1.3 1.3 0 0 1 1.839 0M10.01 21.65l-2.4-2.401a1.3 1.3 0 0 1 0-1.838L19.7 5.303c.82-.82 2.22-.24 2.22.918v9.52c0 1.158-1.4 1.738-2.219.919l-1.431-1.432-6.421 6.423a1.3 1.3 0 0 1-1.84 0"
      />
      <path
        fill="#60B100"
        d="m10.93 20.731-2.4-2.401L20.62 6.221v9.52l-1.89-1.892a.65.65 0 0 0-.92 0z"
      />
      <path
        fill="#FF1212"
        d="M13.101 3.299 15.5 5.7 3.41 17.81V8.29l1.89 1.891a.65.65 0 0 0 .92 0z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default BikeChange;
